export enum StatusGlobal {
  NotStarted, //انجام نشده
  Reported, // گزارش داده
  InProgress, // در حال انجام
  PendingPayment, //  در انتظار پرداخت
  Completed, // انجام شده
  Canceled, // لغو شده
  Completed2, // انجام شده(دورکار)
}

export const ListOfStatusGlobal = [
  { label: "انجام نشده", value: StatusGlobal.NotStarted, color: "default" },
  { label: "گزارش داده", value: StatusGlobal.Reported, color: "info" },
  { label: "آماده انجام", value: StatusGlobal.InProgress, color: "warning" },
  {
    label: "در انتظار پرداخت",
    value: StatusGlobal.PendingPayment,
    color: "secondary",
  },
  {
    label: "انجام شده(دورکار)",
    value: StatusGlobal.Completed2,
    color: "success",
  },

  { label: "انجام شده", value: StatusGlobal.Completed, color: "success" },
  { label: "لغو شده", value: StatusGlobal.Canceled, color: "error" },
];
